import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { filterActions } from '../../model/actions';
import { useRequestFilterCommands } from '../../model/commandsContext';

const selectFilterChanged = (state) => state.filterStore.filterChanged;

export const useFilterChangedState = ({
  shouldUpdateRequests = false,
} = {}) => {
  const filterChanged = useSelector(selectFilterChanged);
  const filterCommands = useRequestFilterCommands();

  const dispatch = useDispatch();

  const action = useCallback(() => {
    if (filterChanged) {
      if (shouldUpdateRequests) {
        dispatch(filterCommands.fetchRequests());
      }

      dispatch(filterActions.setFilterChanged(false));
    }
  }, [dispatch, filterChanged, filterCommands, shouldUpdateRequests]);

  const state = useMemo(
    () => ({ changed: filterChanged, reset: action }),
    [filterChanged, action]
  );

  return state;
};
